import { translate } from '../../util/translate'

import MapDrawing from '@/views/MapDrawing'
import Recharge from '@/views/Recharge'
import AppointmentList from '@/views/AppointmentList'
import AppointmentDetails from '@/views/AppointmentDetails'
import Board from '@/views/Board'
import IntegrationList from '@/views/IntegrationList'
import MovementList from '@/views/MovementList'
import RealtyList from '@/views/RealtyList'
import RealEstateUsersList from '@/views/RealEstateUsersList'
import BranchList from '@/views/BranchList'
import Reports from '@/views/Reports'
import AppointmentDashboard from '@/views/appointmentDashboard/components/AppointmentDashboard'
import CustomerReceivedInvoices from '@/views/invoices/customer/CustomerReceivedInvoices.vue'
import DisputeList from '@/views/dispute/DisputeList'

let webRoute = [
  {
    path: '/group-map',
    name: 'customerGroupMap',
    component: MapDrawing,
    meta: {
      login: true,
      title: translate['pages.title.groupMap'],
      icon: 'mdi-map-marker-multiple-outline',
      roles: ['ROLE_REAL_ESTATE', 'ROLE_COMPANY'],
    },
  },
  {
    path: '/board',
    name: 'board',
    component: Board,
    meta: {
      login: true,
      title: translate['pages.title.board'],
      icon: 'mdi-file-cabinet',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    name: 'appointments',
    path: '/appointments',
    component: AppointmentList,
    meta: {
      login: true,
      title: translate['pages.title.appointmentList'],
      icon: 'mdi-calendar-month-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    name: 'disputes',
    path: '/disputes',
    component: DisputeList,
    meta: {
      login: true,
      title: translate['pages.title.disputeList'],
      icon: 'mdi-text-box-search-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/appointments/:id',
    name: 'appointmentsDetails',
    component: AppointmentDetails,
    meta: {
      login: true,
      title: translate['pages.title.appointmentDetails'],
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/realties',
    name: 'realties',
    component: RealtyList,
    meta: {
      login: true,
      title: translate['pages.title.realtyList'],
      icon: 'mdi-home-city-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/invoices',
    name: 'invoices',
    component: CustomerReceivedInvoices,
    meta: {
      login: true,
      title: translate['pages.title.receivedInvoices'],
      icon: 'mdi-text-box-check-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/movements',
    name: 'movements',
    icon: 'mdi-book-open-variant',
    component: MovementList,
    meta: {
      login: true,
      title: translate['pages.title.movementList'],
      icon: 'mdi-book-open-variant',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/real-estate-users',
    name: 'realEstateUsers',
    component: RealEstateUsersList,
    meta: {
      login: true,
      title: translate['pages.title.users'],
      icon: 'mdi-card-account-details-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/branches',
    name: 'branches',
    component: BranchList,
    meta: {
      login: true,
      title: translate['pages.title.branches'],
      icon: 'mdi-office-building-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: {
      login: true,
      title: translate['pages.title.reports'],
      icon: 'mdi-file-chart-outline',
      roles: ['ROLE_REAL_ESTATE', 'ROLE_PEOPLE'],
    },
  },

  {
    path: '/recharge',
    name: 'recharge',
    component: Recharge,
    meta: {
      login: true,
      title: translate['pages.title.rechargeList'],
      icon: 'mdi-credit-card-sync-outline',
      roles: ['ROLE_REAL_ESTATE'],
      hideForAustralia: true
    },
  },

  {
    path: '/charge',
    name: 'charge',
    component: Recharge,
    meta: {
      login: true,
      title: translate['pages.title.chargeList'],
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  {
    path: '/integration',
    name: 'integration',
    component: IntegrationList,
    meta: {
      login: true,
      title: translate['pages.title.integration'],
      icon: 'mdi-key-outline',
      roles: ['ROLE_REAL_ESTATE'],
    },
  },

  // Deliberately no `meta.icon`: SidebarMainMenu only mounts routes that have one, and the plan is an
  // account matter, not an operational area. It is reached from the account menu (UserOptions).
  {
    path: '/my-plan',
    name: 'myPlan',
    component: () => import('@/views/myPlan/MyPlan.vue'),
    meta: {
      login: true,
      title: translate['pages.title.myPlan'],
      roles: ['ROLE_REAL_ESTATE', 'ROLE_COMPANY'],
    },
  },
]

const qaCnpj = '16788643000181';
const hausefulQaId = '06d58ef5-e0ae-4651-9fc2-6b59c67946d6'

if (localStorage.getItem('users_real_estate_cnpj') == qaCnpj || localStorage.getItem('users_real_estate_id') == hausefulQaId) {
  webRoute.push({
    name: 'appointmentDashboard',
    path: '/appointment-dashboard',
    component: AppointmentDashboard,
    meta: {
      login: true,
      title: translate['pages.title.appointmentDashboard'],
      icon: 'mdi-view-dashboard-variant',
      roles: ['ROLE_REAL_ESTATE'],
    },
  })
}

export { webRoute }
